import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=2e9d72fa&scoped=true&"
import script from "./MoneyInput.vue?vue&type=script&lang=ts&"
export * from "./MoneyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d72fa",
  null
  
)

export default component.exports